module.exports = __webpack_public_path__ + "img/Orchid1.c3ad9b23.jpg";